var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 160 98",
    enableBackground: "new 0 0 160 98",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#020203",
    d: "M129.8,62.9c0,0-0.6-0.2-1.1-0.4c-0.1,0-0.1-0.1-0.1-0.1 c-0.2-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.1-0.2,0.2-0.1c0.2,0,0.2,0.1,0.8,0.2c0.6,0.1,1,0,1.3,0c0.3,0,0.5-0.1,0.8-0.2 c0.4-0.1,1-0.3,1.5-0.4c0.5-0.2,0.9-0.3,1.2-0.4c0.3-0.1,0.8-0.1,1.1,0.1c0.4,0.1,0.5,0.3,0.8,0.5c0.3,0.3,0.6,0.5,1,0.9 c0.3,0.3,1,1,1.2,1.3c0.2,0.3,1.2,1.4,1.2,1.4s1.1-0.4,1.7-0.6c0.6-0.2,1.2-0.4,1.6-0.4c0.3,0,0.9-0.1,1.5,0.1 c0.6,0.2,0.9,0.6,1.1,0.9c0.1,0.2,0.3,0.9,0.4,1.2c0,0.7,0,1.2-0.2,1.9c-0.2,0.7-0.4,1.2-0.5,1.5c-0.1,0.2-0.2,0.4-0.2,0.4 s1,0.4,1.5,0.6c0.5,0.2,0.9,0.3,1.4,0.5c0.5,0.1,1.1,0.3,1.4,0.3c0.3,0.1,1.2,0.2,1.3,0.2c0.1,0,0.2,0,0.1,0.1 c-0.1,0.1-0.4,0.2-1,0.2c-0.7,0-0.9,0-0.9,0s0.1,0.1,0.5,0.2c0.4,0.1,0.4,0.1,0.5,0.1c0.1,0,0.2,0.1,0,0.1c-0.2,0-0.4,0.1-0.8,0 c-0.4,0-0.7-0.1-0.9-0.2c-0.2,0-0.3-0.1-0.3-0.1s0.1,0.1,0.3,0.2c0.2,0.1,0.2,0.1,0.3,0.1c0,0,0.2,0.1,0,0.1c-0.2,0-0.3,0-0.6,0 c-0.2-0.1-0.4-0.1-0.6-0.2c-0.2-0.1-0.4-0.2-0.4-0.2s0.1,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.1,0.2c0,0,0,0.1-0.1,0.1 c-0.1,0-0.3-0.1-0.5-0.2c-0.2-0.1-0.3-0.2-0.3-0.2s0,0.1,0,0.2c0,0.1,0,0.2,0,0.2c0,0.1,0,0.1-0.1,0c-0.1-0.1-0.5-0.4-0.7-0.6 c-0.1-0.1-0.7-0.6-0.9-0.7c-0.1-0.1-0.2-0.2-0.2-0.2s-0.1,0.1-0.4,0.6c-0.4,0.5-0.8,0.9-1,1.1c-0.2,0.2-0.3,0.2-0.4,0.3 c-0.1,0.1-0.3,0.1-0.2-0.1c0.1-0.1,0.3-0.4,0.5-0.6c0.2-0.3,0.2-0.4,0.3-0.6c0.1-0.2,0.1-0.3,0.1-0.3s-0.2,0.3-0.5,0.6 c-0.4,0.5-0.5,0.5-0.8,0.7c-0.5,0.4-1.2,0.7-1.7,0.8c-0.4,0.1-0.5,0.1-0.6,0.1c-0.1,0-0.3,0-0.1-0.1c0.3-0.1,0.5-0.3,0.9-0.5 c0.4-0.2,0.8-0.6,0.9-0.7c0.1-0.1,0.2-0.2,0.3-0.3c0.1-0.1,0.2-0.2,0.2-0.2s-0.2,0.1-0.8,0.5c-0.6,0.3-1.1,0.5-1.5,0.6 c-0.4,0.1-1.1,0.3-2,0.3c-0.9,0-1.3-0.1-1.4-0.2c-0.1,0-0.2-0.2,0.1-0.2c0.3,0,0.9,0,1.7-0.2c0.8-0.2,1.4-0.5,1.7-0.6 c0.4-0.2,1-0.5,1-0.5s-0.6,0.2-1.2,0.3c-0.6,0.1-0.9,0.1-1.4,0.1c-0.4,0-0.6-0.1-0.7-0.2c-0.2-0.1-0.2-0.2,0.1-0.2 c0.3,0,0.6,0,1.2-0.2c0.6-0.2,1.4-0.5,1.6-0.6c0.2-0.1,0.4-0.2,0.4-0.2s-0.7,0.2-1.2,0.2c-0.5,0-0.6-0.1-0.7-0.1 c-0.1,0-0.2-0.1,0-0.1c0.2,0,0.7-0.1,1-0.3c0.3-0.1,0.4-0.1,0.6-0.3c0.2-0.1,0.2-0.2,0.2-0.2s-0.3-0.3-0.6-0.7 c-0.3-0.4-0.5-0.7-0.8-1.1c-0.3-0.4-0.6-0.7-1.2-1c-0.5-0.3-0.9-0.3-1.2-0.4c-0.3,0-0.5,0-0.6,0c-0.2,0-0.3,0.1-0.5,0.1 c-0.1,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0c-0.1,0-0.5,0.2-0.8,0.4c-0.3,0.2-0.7,0.5-0.8,0.5c-0.1,0.1-0.2,0.1-0.2,0.1 s0.1-0.3,0.3-0.6c0.2-0.3,0.4-0.5,0.6-0.6c0.1-0.1,0.3-0.2,0.3-0.2s-0.1,0-0.4,0.1c-0.3,0.1-0.5,0.2-0.8,0.4 c-0.3,0.2-0.5,0.3-0.6,0.4c-0.1,0.1-0.2,0.2-0.2,0.2c0,0,0.1-0.5,0.3-0.8c0.2-0.3,0.4-0.5,0.6-0.7c0.3-0.2,0.5-0.3,0.6-0.4 c0.1,0,0.1,0,0.1-0.1c0-0.1,0.1-0.2,0.2-0.4c0.2-0.2,0.4-0.4,0.4-0.4s0,0-0.1,0c-0.1,0-0.4,0-0.8,0.1c-0.3,0.1-0.6,0.2-1,0.4 c-0.4,0.1-0.8,0.2-1.3,0.2c-0.5,0-0.5,0-0.7,0c-0.1,0-0.2-0.1,0-0.1c0.2,0,0.8-0.3,1.2-0.4c0.4-0.2,0.6-0.3,0.6-0.4 c0.1-0.1,0.1-0.1,0.1-0.1s-0.4,0.2-0.8,0.3c-0.4,0.1-1.2,0.3-1.6,0.3c-0.4,0-1.1,0-1.6-0.2c-0.5-0.1-0.9-0.3-1-0.3 c-0.1-0.1-0.1-0.1,0-0.1c0.1,0,0.4,0,0.8,0.1c0.5,0,1,0,1.3,0c0.3,0,0.9-0.2,1-0.2c0.1,0,0.1,0,0.1,0s-1,0.1-1.8-0.1 c-0.8-0.1-1.4-0.3-2.1-0.5c-0.7-0.2-1.5-0.6-1.7-0.8c-0.3-0.2-0.2-0.3,0-0.2c0.2,0,0.8,0.3,1.5,0.4c0.6,0.1,1.1,0.2,1.6,0.3 c0.5,0,1.4,0,1.6,0c0.2,0,0.2,0,0.2,0s-0.6-0.1-1.2-0.2c-0.7-0.2-1.4-0.5-1.6-0.7c-0.2-0.1-0.2-0.2,0-0.2c0.3,0.1,0.4,0.1,1.2,0.2 c0.8,0.1,0.8,0.1,1.1,0.1C129.5,63,129.8,62.9,129.8,62.9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#020203",
    d: "M131.7,58.3c0,0,0.1-0.4,0.6-0.7c0.4-0.3,0.8-0.5,1-0.6 c0.3-0.1,0.3-0.1,0.3-0.1s0.2-0.3,0.4-0.4c0.2-0.2,0.2-0.3,0.6-0.5c0.2-0.1,0.4-0.2,0.4-0.2s-0.4-0.1-1.2-0.1c-0.8,0-1.6,0-2.2,0.1 c-0.6,0.1-1.5,0.1-2.3,0.1c-0.8,0-1.5,0-2.3-0.2c-0.8-0.2-1.6-0.5-2-0.7c-0.4-0.2-1.3-0.7-1.8-1.3c-0.4-0.5-0.7-0.9-0.8-1.3 c-0.1-0.3-0.1-0.4-0.2-0.5c0-0.1-0.1-0.2,0.1-0.1c0.2,0.2,0.4,0.4,0.6,0.7c0.3,0.3,0.5,0.5,0.6,0.6c0.1,0.1,0.1,0.1,0.1,0.1 s-0.1-0.3-0.1-0.3c0-0.1-0.1-0.3,0.1-0.1c0.1,0.1,0.1,0.2,0.5,0.5c0.4,0.3,0.6,0.5,0.8,0.6c0.2,0.1,0.2,0.1,0.2,0.1 s-0.2-0.3-0.2-0.4c-0.1-0.1-0.1-0.2-0.1-0.2c0-0.1,0-0.1,0.1,0c0.1,0.1,0.1,0.2,0.4,0.4c0.2,0.2,0.3,0.3,0.6,0.4 c0.1,0.1,0.5,0.2,0.5,0.2s-0.2-0.2-0.2-0.3c-0.1-0.1-0.1-0.3,0-0.2c0.1,0.1,0.6,0.4,1.1,0.6c0.5,0.1,0.9,0.2,1.7,0.1 c0.8-0.1,2.1-0.5,2.4-0.5c0.4-0.1,1.3-0.2,2-0.1c0.6,0.1,0.9,0.2,1.4,0.4c0.5,0.1,1.2,0.4,1.9,0.5c0.7,0.2,1.2,0.3,2,0.2 c0.8,0,0.9-0.1,1.4-0.3c0.5-0.2,1.6-0.9,2-1.1c0.4-0.2,1.3-0.7,2-0.9c0.7-0.2,1.3-0.2,1.7-0.2c0.4,0,0.9,0.1,1.5,0.1 c0.6,0.1,1.1,0.1,1.5,0.2c0.4,0,0.9,0,1.5,0c0.6,0,1.3-0.2,1.5-0.3c0.2-0.1,0.7-0.3,0.7-0.4c0.1-0.1,0.1-0.1,0.1,0 c-0.1,0.1-0.2,0.2-0.4,0.4c-0.2,0.1-0.4,0.3-0.4,0.3s0.4,0,1-0.2c0.5-0.2,0.9-0.3,1.1-0.5c0.2-0.1,0.5-0.3,0.5-0.4 c0,0,0.2-0.1,0.1,0.1c-0.1,0.2-0.5,0.5-0.8,0.7c-0.3,0.2-0.9,0.5-1.4,0.7c-0.5,0.1-0.9,0.2-0.9,0.2s0.6,0,1.2-0.1 c0.6-0.1,0.9-0.3,1.3-0.4c0.4-0.2,1-0.5,1.3-0.7c0.2-0.2,0.2-0.2,0.3-0.2c0,0,0.1-0.1,0,0c-0.1,0.1-0.4,0.5-0.9,0.8 c-0.5,0.4-0.8,0.5-1.2,0.7c-0.4,0.2-1.2,0.4-1.6,0.4c-0.4,0.1-0.8,0-1,0c-0.2,0-0.3,0-0.3,0s0,0.1,0.6,0.2c0.6,0.1,1.2,0,1.6-0.1 c0.3,0,0.4-0.1,0.5-0.1c0.1,0,0.2,0,0.1,0.1c-0.1,0.1-0.8,0.4-1.3,0.5c-0.7,0.1-1.2,0.1-1.8,0c-0.6-0.1-1-0.1-1-0.1 s0.3,0.2,0.7,0.2c0.4,0.1,0.5,0.1,0.6,0.1c0.1,0,0.1,0-0.1,0.1c-0.2,0.1-0.6,0.2-1.2,0.1c-0.6-0.1-0.9-0.2-1.1-0.2 c-0.2,0-0.7-0.1-1.3,0c-0.6,0.1-1.5,0.5-1.9,0.8c-0.4,0.2-1,0.6-1.5,0.7c-0.4,0.2-0.6,0.2-0.7,0.2c-0.1,0-0.1,0-0.1,0 s0.3,0.1,0.7,0.2c0.4,0.1,1,0.2,1.7,0.2c0.8,0,1.3,0,1.7-0.1c0.6-0.1,2.1-0.4,2.4-0.5c0.3-0.1,0.5-0.1,0.3,0 c-0.1,0.2-0.4,0.3-0.5,0.4c-0.2,0.1-0.3,0.1-0.3,0.1s0,0,0.1,0c0.1,0,0.1,0.1,0,0.1c-0.1,0.1-0.3,0.2-0.6,0.3 c-0.3,0.1-0.3,0.1-0.3,0.1s0,0,0.1,0c0,0,0.1,0,0,0.1c0,0-0.2,0.2-0.5,0.2c-0.3,0.1-0.5,0.1-0.5,0.1s0,0,0,0.1c0,0.1,0,0.1-0.1,0.1 c-0.1,0-0.4,0-0.5,0c-0.1,0-0.3,0-0.3,0s-0.1,0.1-0.2,0.1c-0.1,0-0.3,0-0.6-0.1c-0.3,0-0.5-0.1-0.7-0.1c-0.2,0-0.2,0-0.5,0.1 c-0.2,0.1-1.2,0.4-2,0.6c-0.8,0.1-1.4,0.2-2.1,0.2c-0.7,0-1.4-0.1-2-0.2c-0.5-0.1-0.8-0.2-1.7-0.4c-1-0.2-1-0.2-1.3-0.2 c-0.3,0-0.8,0.1-1.7,0.2c-0.9,0.2-0.9,0.2-1.1,0.2C131.9,58.2,131.7,58.3,131.7,58.3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 28.1,
    fill: "#020203",
    width: 0.8,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.1,
    y: 24.5,
    fill: "#020203",
    width: 0.8,
    height: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 37.2,
    fill: "#020203",
    width: 0.8,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 24.5,
    fill: "#020203",
    width: 0.8,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 49.6,
    fill: "#020203",
    width: 0.8,
    height: 8.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    y: 28.1,
    fill: "#020203",
    width: 0.8,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.2,
    fill: "#020203",
    width: 0.8,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.4,
    y: 28.1,
    fill: "#020203",
    width: 0.8,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 52.3,
    fill: "#020203",
    width: 0.8,
    height: 9.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 88.4,
    fill: "#020203",
    width: 0.8,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1,
    y: 88.4,
    fill: "#020203",
    width: 0.8,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 46.3,
    fill: "#020203",
    width: 0.8,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 46.3,
    fill: "#020203",
    width: 0.8,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.3,
    y: 69.6,
    fill: "#020203",
    width: 0.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.4,
    y: 69.6,
    fill: "#020203",
    width: 0.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 88.4,
    fill: "#020203",
    width: 0.8,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3,
    y: 69.6,
    fill: "#020203",
    width: 0.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.9,
    y: 67.4,
    fill: "#020203",
    width: 19.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M19.6,25.3c1.6,0,2.9,1.3,2.9,2.9h0.7c0-2-1.7-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6h0.7 C16.7,26.5,18,25.3,19.6,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M23.2,44.3c-0.2-1.8-1.7-3.2-3.6-3.2c-1.9,0-3.4,1.4-3.6,3.2H8.9v0.8h7.8v-0.5c0.1-1.5,1.3-2.8,2.9-2.8 c1.6,0,2.9,1.3,2.9,2.9v0.4h7.4v-0.8H23.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M63.1,44.3c-0.2-1.8-1.7-3.2-3.6-3.2c-1.9,0-3.4,1.4-3.6,3.2h-5.8v0.8h6.5v-0.5c0.1-1.6,1.3-2.8,2.9-2.8 c1.6,0,2.9,1.3,2.9,2.9v0.4H68v-0.8H63.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M60,64.2c-1.9,0-3.4,1.4-3.6,3.2H43.8v0.8h13.3v-0.5c0.1-1.5,1.3-2.8,2.9-2.8c1.6,0,2.9,1.3,2.9,2.9l0,0.4 h0.7l0-0.4C63.6,65.8,62,64.2,60,64.2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M59.5,46c-2,0-3.6,1.6-3.6,3.6h0.7c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9h0.7 C63.1,47.6,61.5,46,59.5,46"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M22.8,51.5c-0.2-1.6-1.5-2.8-3.2-2.8c-1.6,0-3,1.2-3.2,2.8h-2.2v0.7h2.9v-0.5c0.1-1.3,1.2-2.3,2.5-2.3 c1.3,0,2.4,1.1,2.5,2.4v0.4h2v-0.7H22.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M21.6,22.4c-0.3-0.8-1-1.4-2-1.4c-0.9,0-1.7,0.6-2,1.4H9.8v0.8h8.5v-0.1h0c0,0,0,0,0,0v0 c0-0.7,0.6-1.3,1.4-1.3c0.8,0,1.4,0.6,1.4,1.3v0c0,0,0,0,0,0h0v0.1h7.6v-0.8H21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M20,8.7V7.9c-4.3,1.9-7.3,6.2-7.3,11.3c0,0.3,0,0.6,0,0.9h0.8c0-0.3,0-0.6,0-0.9 C13.5,14.6,16.1,10.6,20,8.7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.1,
    y: 28.1,
    fill: "#020203",
    width: 0.8,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.6,
    y: 24.5,
    fill: "#020203",
    width: 0.8,
    height: 18.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 37.2,
    fill: "#020203",
    width: 0.8,
    height: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 24.5,
    fill: "#020203",
    width: 0.8,
    height: 15.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.6,
    y: 52.4,
    fill: "#020203",
    width: 0.8,
    height: 9.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    y: 28.1,
    fill: "#020203",
    width: 0.8,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    fill: "#020203",
    width: 0.8,
    height: 8.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 28.1,
    fill: "#020203",
    width: 0.8,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 88.4,
    fill: "#020203",
    width: 0.8,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 88.4,
    fill: "#020203",
    width: 0.8,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 69.6,
    fill: "#020203",
    width: 0.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 46.3,
    fill: "#020203",
    width: 0.8,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 46.3,
    fill: "#020203",
    width: 0.8,
    height: 19.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.9,
    y: 69.6,
    fill: "#020203",
    width: 0.8,
    height: 5.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.4,
    y: 67.4,
    fill: "#020203",
    width: 19.7,
    height: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M99.2,25.3c1.6,0,2.9,1.3,2.9,2.9h0.7c0-2-1.7-3.6-3.6-3.6c-2,0-3.6,1.6-3.6,3.6h0.7 C96.3,26.5,97.6,25.3,99.2,25.3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M102.8,44.3c-0.2-1.8-1.7-3.2-3.6-3.2c-1.9,0-3.4,1.4-3.6,3.2h-7.1v0.8h7.8v-0.5c0.1-1.6,1.3-2.8,2.9-2.8 c1.6,0,2.9,1.3,2.9,2.9v0.4h7.4v-0.8H102.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M102.4,51.5c-0.2-1.6-1.5-2.8-3.2-2.8c-1.6,0-3,1.2-3.2,2.8h-2.2v0.7h2.9v-0.4c0.1-1.3,1.1-2.4,2.5-2.4 s2.4,1.1,2.5,2.4v0.4h2v-0.7H102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M101.1,22.4c-0.3-0.8-1-1.4-2-1.4c-0.9,0-1.7,0.6-2,1.4h-7.9v0.8h8.5v-0.1h0c0,0,0,0,0,0v0 c0-0.7,0.6-1.3,1.4-1.3c0.7,0,1.3,0.6,1.4,1.3v0.2h7.6v-0.8H101.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M99.6,8.7V7.9c-4.3,1.9-7.3,6.2-7.3,11.3c0,0.3,0,0.6,0,0.9h0.8c0-0.3,0-0.6,0-0.9 C93.1,14.6,95.7,10.6,99.6,8.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M51.9,46.3h-0.4h-0.4c-0.4,9.9-7.4,17.4-16.6,19.7h0v2.3h0.8v-1.7C44.6,64,51.6,56.3,51.9,46.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "0,77.7 0.8,77.7 0.8,81.2 4.4,77.7 5.4,77.7 1.5,81.4 5.7,85.6 4.6,85.6 0.8,81.6 0.8,85.6 0,85.6 "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "10.3,77.7 11.1,77.7 11.1,84.9 14.3,84.9 14.3,85.6 10.3,85.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M22,77.5c2.4,0,3.5,2,3.5,4.1c0,2.4-1.2,4.1-3.5,4.1c-2.3,0-3.5-1.7-3.5-4.1C18.5,79.5,19.6,77.5,22,77.5  M19.3,81.6c0,1.7,0.8,3.4,2.7,3.4s2.7-1.7,2.7-3.4c0-1.7-0.8-3.4-2.7-3.4S19.3,80,19.3,81.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M30.4,84.6c0.5,0.3,1,0.5,1.8,0.5c1,0,1.8-0.5,1.8-1.6c0-1.6-3.7-1.8-3.7-3.9c0-1.3,1.1-2.1,2.5-2.1 c0.4,0,1,0.1,1.6,0.3l-0.1,0.7c-0.4-0.2-0.9-0.3-1.5-0.3c-0.8,0-1.7,0.3-1.7,1.4c0,1.6,3.7,1.6,3.7,3.9c0,1.6-1.4,2.3-2.6,2.3 c-0.8,0-1.4-0.2-1.8-0.3L30.4,84.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "41.3,78.3 38.9,78.3 38.9,77.7 44.4,77.7 44.4,78.3 42.1,78.3 42.1,85.6 41.3,85.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "49,77.7 52.9,77.7 52.9,78.3 49.8,78.3 49.8,81.2 52.7,81.2 52.7,81.9 49.8,81.9 49.8,84.9 53,84.9 53,85.6 49,85.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M58.2,77.7h2.1c1.4,0,2.3,0.6,2.3,2.1c0,1-0.8,1.7-1.8,1.8v0c0.6,0.1,0.8,0.4,1,1l1.4,3.1h-0.9l-1.2-2.7 c-0.5-1-0.8-1.1-1.6-1.1H59v3.8h-0.8V77.7z M59,81.2h0.8c0.9,0,2-0.4,2-1.5c0-1.3-0.9-1.4-2-1.4H59V81.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "74.6,77.7 78.5,77.7 78.5,78.3 75.4,78.3 75.4,81.2 78.4,81.2 78.4,81.9 75.4,81.9 75.4,84.9 78.7,84.9 78.7,85.6 74.6,85.6  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.8,
    y: 77.7,
    fill: "#020203",
    width: 0.8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "89.8,77.7 90.8,77.7 94.9,84.7 94.9,84.7 94.9,77.7 95.7,77.7 95.7,85.6 94.6,85.6 90.6,78.8 90.6,78.8 90.6,85.6 89.8,85.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M100.8,84.6c0.5,0.3,1,0.5,1.8,0.5c1,0,1.8-0.5,1.8-1.6c0-1.6-3.7-1.8-3.7-3.9c0-1.3,1.1-2.1,2.5-2.1 c0.4,0,1,0.1,1.6,0.3l-0.1,0.7c-0.4-0.2-0.9-0.3-1.5-0.3c-0.8,0-1.7,0.3-1.7,1.4c0,1.6,3.7,1.6,3.7,3.9c0,1.6-1.4,2.3-2.6,2.3 c-0.8,0-1.4-0.2-1.8-0.3L100.8,84.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.1,
    y: 77.7,
    fill: "#020203",
    width: 0.8,
    height: 8
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "116.2,77.7 120.1,77.7 120.1,78.3 117,78.3 117,81.2 120,81.2 120,81.9 117,81.9 117,84.9 120.3,84.9 120.3,85.6 116.2,85.6  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020203",
    d: "M125.3,77.7h2c2.9,0,4,1.6,4,4c0,2.9-1.9,4-4.6,4h-1.4V77.7z M126.1,84.9h0.6c2.3,0,3.8-0.9,3.8-3.4 c0-2.4-1.5-3.2-3.3-3.2h-1.1V84.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "136.5,77.7 140.4,77.7 140.4,78.3 137.3,78.3 137.3,81.2 140.3,81.2 140.3,81.9 137.3,81.9 137.3,84.9 140.5,84.9 140.5,85.6 136.5,85.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "145.6,77.7 146.4,77.7 146.4,84.9 149.6,84.9 149.6,85.6 145.6,85.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#020203",
    points: "154.1,77.7 155.1,77.7 159.2,84.7 159.2,84.7 159.2,77.7 160,77.7 160,85.6 158.9,85.6 154.9,78.8 154.9,78.8 154.9,85.6 154.1,85.6  "
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.eda074c0d8da09abe5757ec34a973797.svg";
export { ForwardRef as ReactComponent };